import type {
  PermissionAccessControlType,
  PermissionEntityType,
  PermissionResourceType,
  UserPermissionType,
} from './types';

type UserPermissionKeyType =
  `${PermissionResourceType}${PermissionEntityType}${PermissionAccessControlType}`;

export const UserPermissions: Partial<
  Record<UserPermissionKeyType, UserPermissionType>
> = {
  OrganizationsOrganizationRead: 'organizations.organization.read',
  OrganizationsOrganizationManage: 'organizations.organization.manage',
  OrganizationsEmployeeRead: 'organizations.employee.read',
  OrganizationsEmployeeManage: 'organizations.employee.manage',
  OrganizationsCounterpartiesRead: 'organizations.counterparties.read',
  OrganizationsCounterpartiesWrite: 'organizations.counterparties.write',
  OrganizationsContractsRead: 'organizations.contracts.read',
  OrganizationsContractsWrite: 'organizations.contracts.write',
  OrganizationsUndistributedPaymentsRead:
    'organizations.undistributedpayments.read',
  OrganizationsUndistributedPaymentsWrite:
    'organizations.undistributedpayments.write',
  OrganizationsIncomingPaymentsRead: 'organizations.incomingpayments.read',
  OrganizationsIncomingPaymentsWrite: 'organizations.incomingpayments.write',
  OrganizationsPricesAndTariffsRead: 'organizations.pricesandtariffs.read',
  OrganizationsPricesAndTariffsWrite: 'organizations.pricesandtariffs.write',
  OrganizationsActsAndInvoicesRead: 'organizations.actsandinvoices.read',
  OrganizationsActsAndInvoicesWrite: 'organizations.actsandinvoices.write',
  OrganizationsConsumptionObjectsRead: 'organizations.consumptionobjects.read',
  OrganizationsConsumptionObjectsWrite:
    'organizations.consumptionobjects.write',
  OrganizationsRoleAndPermissionRead: 'organizations.roleandpermission.read',
  OrganizationsRoleAndPermissionWrite: 'organizations.roleandpermission.manage',
  ConsumptionAccountingForecastingRead:
    'consumptionaccounting.forecasting.read',
  ConsumptionAccountingForecastingWrite:
    'consumptionaccounting.forecasting.write',
  ConsumptionAccountingNominationRead: 'consumptionaccounting.nomination.read',
  ConsumptionAccountingNominationWrite:
    'consumptionaccounting.nomination.write',
  ConsumptionAccountingPreliminaryAllocationRead:
    'consumptionaccounting.preliminaryallocation.read',
  ConsumptionAccountingPreliminaryAllocationWrite:
    'consumptionaccounting.preliminaryallocation.write',
  ConsumptionAccountingFinalAllocationRead:
    'consumptionaccounting.finalallocation.read',
  ConsumptionAccountingFinalAllocationWrite:
    'consumptionaccounting.finalallocation.write',
  GasBalanceBalancingGroupRead: 'gasbalance.balancinggroup.read',
  GasBalanceBalancingGroupWrite: 'gasbalance.balancinggroup.write',
  GasBalanceFinancialSecurityRead: 'gasbalance.financialsecurity.read',
  GasBalanceFinancialSecurityWrite: 'gasbalance.financialsecurity.write',
  GasBalanceBalanceRead: 'gasbalance.balance.read',
  GasBalanceBalanceWrite: 'gasbalance.balance.write',
  GasBalanceImbalanceRead: 'gasbalance.imbalance.read',
  GasBalanceImbalanceWrite: 'gasbalance.imbalance.write',
  GasBalanceResourceRead: 'gasbalance.resource.read',
  GasBalanceResourceWrite: 'gasbalance.resource.write',
  SettingsImbalanceSettingsRead: 'settings.imbalancesettings.read',
  SettingsImbalanceSettingsWrite: 'settings.imbalancesettings.write',
  SettingsCapacitySettingsRead: 'settings.capacitysettings.read',
  SettingsCapacitySettingsWrite: 'settings.capacitysettings.write',
  SettingsPsoFormulaRead: 'settings.psoformula.read',
  SettingsPsoFormulaWrite: 'settings.psoformula.write',
  ReportsAndAnalyticsReportRead: 'reportsandanalytics.report.read',
  ReportsAndAnalyticsReportWrite: 'reportsandanalytics.report.write',
  ReportsAndAnalyticsBiDashboardsRead: 'reportsandanalytics.bidashboards.read',
};
